import { render, staticRenderFns } from "./MessageAgg.vue?vue&type=template&id=e3186ffa&"
import script from "./MessageAgg.vue?vue&type=script&lang=js&"
export * from "./MessageAgg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports